
import {
  addDocument,
  editorDocument,
  getKnowledgeScourceList,
  getScource,
} from "@/api/knowledge";
import { getQiniuToken } from "@/api/third";
import { UserModule } from "@/store/modules/user";
import { Qiniu } from "@/types/qiniu";
import { makeKey } from "@/utils/qiniu";
import { Component, Prop, Vue } from "vue-property-decorator";
import Tinymce from "../announcements/Tinymce/index.vue";

@Component({
  name: "KnowledgeAddDocument",
  components: {
    Tinymce,
  },
})
export default class extends Vue {
  private richForm: any = {
    title: "",
    group: "",
    richtext: "",
  };
  // 骑牛
  private qiuniuToken: any = {
    action_url: "",
  };
  private qiuniuform: any = {};

  private fileList: any = [];
  private groupOptions = [];

  private detail: any = {};
  created() {
    this.getKnowledgeScourceList();
    let params = {
      type: Qiniu.UPLOAD_TYPE_KNOWLEDGE,
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiuniuToken = res.data;
      }
    });
    if (this.$route.query.id) {
      this.getKnowledgeDetail();
    }
  }
  private getKnowledgeScourceList() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      type: 0,
      pid: this.$route.query.pid,
      is_collection: 1,
      page: 1,
      size: 9999,
    };
    getKnowledgeScourceList(params).then((res) => {
      if (res.data && res.data.list) {
        this.groupOptions = res.data.list;
      } else {
        this.groupOptions = [];
      }
    });
  }
  private getKnowledgeDetail() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      id: this.$route.query.id,
    };
    getScource(params).then((res) => {
      if (res.data) {
        this.detail = res.data;
        this.richForm.title = res.data.name;
        this.richForm.richtext = res.data.content;
        if (res.data.files) {
          this.fileList = res.data.files;
        } else {
          this.fileList = [];
        }
      }
    });
  }

  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
  }
  private handleSuccess(res: any, file: any, fileList: any) {
    this.fileList = fileList;
  }
  private beforeUpload(file: any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      if (file.type === "video/mp4") {
        this.$set(
          this.qiuniuform,
          "key",
          makeKey(this.qiuniuToken.prekey) + ".mp4"
        );
        this.$set(this.qiuniuform, "token", this.qiuniuToken.uptoken);
        this.$set(this.qiuniuform, "domain", this.qiuniuToken.domain);
      } else {
        this.$set(this.qiuniuform, "key", makeKey(this.qiuniuToken.prekey));
        this.$set(this.qiuniuform, "token", this.qiuniuToken.uptoken);
        this.$set(this.qiuniuform, "domain", this.qiuniuToken.domain);
      }
    });
  }
  private save(status: any) {
    if (!this.richForm.title) {
      this.showErrorMsg("请输入标题");
      return;
    }
    if (!this.richForm.richtext) {
      this.showErrorMsg("请输入内容");
      return;
    }
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      name: this.richForm.title,
      content: this.richForm.richtext,
      status: status,
    };
    if (this.richForm.group && parseInt(this.richForm.group) !== 0) {
      pamars.pid = this.richForm.group;
    } else {
      pamars.pid = this.$route.query.pid;
    }
    let fileLists: any = [];
    if (this.fileList) {
      this.fileList.forEach((element: any) => {
        let fileData: any = {};
        if (element.raw) {
          fileData.name = element.raw.name;
          fileData.content = element.response.key;
          if (element.raw.type.includes("image")) {
            fileData.type = 1;
            fileLists.push(fileData);
          } else if (element.raw.type.includes("audio")) {
            fileData.type = 2;
            fileLists.push(fileData);
          } else if (element.raw.type.includes("video")) {
            fileData.type = 3;
            fileLists.push(fileData);
          } else if (element.raw.type.includes("pdf")) {
            fileData.type = 4;
            fileLists.push(fileData);
          } else if (element.raw.type.includes("sheet")) {
            fileData.type = 5;
            fileLists.push(fileData);
          } else if (element.raw.type.includes("powerpoint")) {
            fileData.type = 6;
            fileLists.push(fileData);
          } else if (element.raw.type.includes("document")) {
            if (element.raw.type.includes("presentation")) {
              fileData.type = 6;
            } else {
              fileData.type = 7;
            }
            fileLists.push(fileData);
          } else if (element.raw.type.includes("plain")) {
            fileData.type = 8;
            fileLists.push(fileData);
          } else {
            fileData.type = 90;
            fileLists.push(fileData);
          }
        } else {
          fileData.name = element.name;
          fileData.content = element.content;
          fileData.type = element.type;
          fileLists.push(fileData);
        }
      });
    }
    if (fileLists.length > 0) {
      pamars.files = JSON.stringify(fileLists);
    }
    if (this.detail && this.detail.id) {
      pamars.id = this.detail.id;
      editorDocument(pamars)
        .then((res: any) => {
          this.showSecussMsg(res.msg);
          this.$router.go(-1);
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    } else {
      addDocument(pamars)
        .then((res: any) => {
          this.showSecussMsg(res.msg);
          this.$router.go(-1);
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
